export default function (Component) {
    Component.options.tsv = [{"label":"Africa","value":49},{"label":"Americas","value":92},{"label":"Asia","value":68},{"label":"Europe","value":90},{"label":"Middle East","value":37}]
  }